import { FeatureType } from '@types';

const getFeatName = (code: FeatureType) => {
  return {
    [FeatureType.scene]: '场景切换',
    [FeatureType.link]: '超链接',
    [FeatureType.mobile]: '电话',
    [FeatureType.map]: '导航',
    [FeatureType.media]: '图文',
    [FeatureType.text]: '文本',
    [FeatureType.doc]: 'PDF',
    [FeatureType.audio]: '音频',
    [FeatureType.video]: '视频',
    [FeatureType.seqFrame]: '逐帧环物',
    [FeatureType.noFunc]: '无功能',
    [FeatureType.article]: '文章',
    [FeatureType.event]: '事件',
    [FeatureType.miniProgram]: '小程序',
    [FeatureType.model3d]: '3D模型',
    [FeatureType.prevScene]: '上一场景',
    [FeatureType.nextScene]: '下一场景',
  }[code];
};

export default getFeatName;
